/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-18T19:58:30.538
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveConDeputeContractBack,
	getConDeputeContractBackCreateInit,
	getConDeputeContractBackEditInit,
	getConDeputeContractBackView,
	deleteConDeputeContractBack
} from '@api/storagemanage/ConDeputeContractBack';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getConDeputeContractBackCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getConDeputeContractBackCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getConDeputeContractBackEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getConDeputeContractBackEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveConDeputeContractBack({}, ConDeputeContractBack) {
			return new Promise((resolve, reject) => {
				saveConDeputeContractBack(ConDeputeContractBack)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getConDeputeContractBackView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getConDeputeContractBackView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteConDeputeContractBack({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteConDeputeContractBack({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
